import { customerByBusinessByPhone } from "graphql/queries";
import { API } from "@aws-amplify/api";

const getByPhone = async (phone, businessID) => {
  const beginsWith =
    phone.substr(0, 1) == "+"
      ? phone
      : phone.substr(0, 2) == "00"
      ? `+${phone.substr(2)}`
      : `+356${phone}`;
  const variables = {
    phone: { beginsWith },
    businessID,
    filter: {
      active: { ne: false },
    },
  };
  const request = await API.graphql({
    query: customerByBusinessByPhone,
    variables,
    authMode: "AMAZON_COGNITO_USER_POOLS",
  });
  return request?.data?.customerByBusinessByPhone?.items;
};

export { getByPhone };
